export { default } from "./SkeletonUserAddressesList-component";
